<template>
  <div class="speaker-profile-page page-container pt-3 pb-4">
    <div class="bio-container mb-4">
      <bio type="mishna" :magidShiur="magidShiur"></bio>
    </div>

    <v-server-table
      ref="magideiShiurTable"
      name="magideiShiurTable"
      v-if="magidShiur.id"
      :url="'/api/magidei-shiur/mishna/' + magidShiur.id + '/shiurim'"
      :columns="columns"
      :options="options"
    >
      <div slot="beforeTable" class="py-3 d-md-none">
        <div class="d-flex flex-wrap w-100 row d-md-none align-items-center justify-content-center">
          <strong clas="col-auto">{{ $_t('KW:sortBy') }}:</strong>
          <button class="col-auto btn btn-sm btn-link" @click="sortItems('book_id')">
            {{ $_t('KW:name') }}
            <i class="fa" :class="setOrderClass('book_id')"></i>
          </button>
          <button class="col-auto btn btn-sm btn-link" @click="sortItems('edited')">
            {{ $_t('KW:date') }}
            <i class="fa" :class="setOrderClass('edited')"></i>
          </button>
          <button class="col-auto btn btn-sm btn-link" @click="sortItems('length')">
            {{ $_t('KW:length') }}
            <i class="fa" :class="setOrderClass('length')"></i>
          </button>
        </div>
        <v-select
          class="select-filter d-md-none my-4"
          v-if="magidShiur && magidShiur.books"
          v-model="filterBook"
          :placeholder="$t('KW:filterByBook')"
          :options="magidShiur.books"
          @input="filterOnBook"
        ></v-select>
      </div>
      <div slot="filter__book_id">
        <v-select
          class="select-filter"
          v-model="filterBook"
          :placeholder="$t('KW:filterByBook')"
          :options="magidShiur.books"
          @input="filterOnBook"
        ></v-select>
      </div>
      <div slot="filter__mobile">
        <v-select
          class="select-filter"
          v-model="filterBook"
          :placeholder="$t('KW:filterByBook')"
          :options="magidShiur.books"
          @input="filterOnBook"
        ></v-select>
      </div>
      <div slot="mobile" slot-scope="props" v-if="props.row && props.row.book">
        <strong>
          <router-link
            :to="{
              name: 'shiur-single',
              params: {
                book: props.row.book.url_key,
                perek: props.row.mishna_chapter,
                mishna: props.row.mishna_number,
              },
            }"
          >
            {{
              $t('KW:mishnaShiurTitle', {
                masechta: props.row.book.name,
                chapter: props.row.mishna_chapter,
                mishna: props.row.mishna_number,
              })
            }}
          </router-link>
        </strong>
        {{ props.row.length }}
        <br />
        <strong>{{ magidShiur.name }}</strong>
      </div>
      <div slot="book_id" slot-scope="props" v-if="props.row && props.row.book">
        <router-link
          :to="{
            name: 'shiur-single',
            params: {
              book: props.row.book.url_key,
              perek: props.row.mishna_chapter,
              mishna: props.row.mishna_number,
            },
          }"
        >
          {{
            $t('KW:mishnaShiurTitle', {
              masechta: props.row.book.name,
              chapter: props.row.mishna_chapter,
              mishna: props.row.mishna_number,
            })
          }}
        </router-link>
      </div>
      <action-buttons slot="actions" :magid-shiur="magidShiur" :shiurim="props.row" type="mishna" slot-scope="props"></action-buttons>
    </v-server-table>
  </div>
</template>
<script>
import VueSelect from 'vue-select';
import { Event as VueTablesEvent } from 'vue-tables-2';
import ActionButtonsComponent from './partials/ActionButtons.vue';
import BioComponent from './magideiShiur/bio.vue';

export default {
  metaInfo: function () {
    return {
      title: this.metaTitle,
      titleTemplate: null,
      meta: [{ name: 'description', content: this.metaTitle }],
    };
  },
  computed: {
    metaTitle: function() {
      return this.magidShiur ? this.$_t('KW:site.metaMishnaWithName', { name: this.magidShiur.name }) : this.$_t('KW:site.metaMishnaWithoutName');
    },
  },
  i18nOptions: {
    namespaces: 'pages',
    keyPrefix: 'magidShiur',
  },
  components: {
    vSelect: VueSelect,
    ActionButtons: ActionButtonsComponent,
    bio: BioComponent,
  },
  data: function() {
    return {
      filterBook: null,
      columns: ['mobile', 'book_id', 'message', 'edited', 'length', 'actions'],
      options: {
        templates: {
          book_id: function(h, row, index) {
            return this.$t('KW:mishnaShiurTitle', {
              masechta: row.book.book.name,
              chapter: row.book.mishna_chapter,
              mishna: row.book.mishna_number,
            });
          },
        },
        headings: {
          mobile: this.$_t('KW:mobile'),
          message: this.$_t('KW:message'),
          length: this.$_t('KW:length'),
          actions: this.$_t('KW:actions'),
          edited: this.$_t('KW:date'),
          book_id: this.$_t('KW:title'),
        },
        sortIcon: {
          base: 'fa fa-sort',
          up: 'fa-sort-amount-asc',
          down: 'fa-sort-amount-desc',
        },
        columnsDisplay: {
          mobile: 'max_tabletP',
          book_id: 'min_tabletL',
          message: 'min_tabletL',
          length: 'min_tabletL',
          edited: 'min_tabletL',
        },
        filterByColumn: true,
        filterable: [],
        customFilters: ['book_id'],
        sortable: ['book_id', 'edited', 'length'],
        highlightMatches: true,
        perPage: 50,
        perPageValues: [25, 50, 100],
      },
      magidShiur: {
        name: null,
        image: {
          name: null,
        },
      },
      loading: false,
      order: {
        column: null,
        isAscending: true,
      },
    };
  },
  created: function() {
    this.getData();
  },
  watch: {
    $route: 'getData',
  },
  methods: {
    filterOnBook: function(value) {
      VueTablesEvent.$emit('vue-tables.magideiShiurTable.filter::book_id', value ? value.value : '0');
    },
    sortItems: function(column) {
      if (this.order.column !== column) {
        this.order.column = column;
        this.order.isAscending = true;
      } else {
        this.order.isAscending = !this.order.isAscending;
      }
      this.$refs.magideiShiurTable.setOrder(this.order.column, this.order.isAscending);
    },
    setOrderClass: function(name) {
      if (name == this.order.column) {
        return this.order.isAscending ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc';
      }
      return 'fa-sort';
    },
    getData: function() {
      let self = this;
      this.loading = true;
      this.$http
        .get('/api/magidei-shiur/mishna/' + this.$route.params.slug)
        .then(function(response) {
          self.magidShiur = response.data;
          self.options.listColumns.book_id = response.data.book;
          self.loading = false;
        })
        .catch(function(error) {
          self.loading = false;
          self.error = true;
        });
    },
  },
};
</script>
